<template>
  <div class="grid">
    <div class="grid_header">
      <div>
        <img class="logo" v-if="companiesConfig.logo" :src="companiesConfig.logo.svg" />
        <p>{{ companiesConfig.company_name }}</p>
        <p>
          {{ localStorage.translations.pages.planning_orders.table['avtor'] }}:
        </p>
      </div>
      <div>
        <p></p>
        <p class="text-primary">{{ companiesConfig?.executor || '—'}}</p>
      </div>
      <div>
        <p>
          {{ localStorage.translations.pages.planning.pages['obem-zakazov'] }}
          {{ new Date().getFullYear() }}
        </p>
        <p class="date">
          {{ localStorage.translations.pages.planning_orders.table['data'] }}:
          <span class="text-primary">{{ formatDate }}</span>
        </p>
      </div>
    </div>
    <slot />
    <div class="d-flex justify-end">
      <p class="fw700" :class="$vuetify.breakpoint.xsOnly ? 'f22' : 'f24'">
        {{
          localStorage.translations.pages.planning_orders.table['obem-zakazov'] + ': ' +
          total.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }) + ' €'
        }}
      </p>
    </div>
    <div class="grid_footer">
      <div>
        <p>{{ companiesConfig?.company_name || '—' }}</p>
        <p>{{ companiesConfig?.registration_address || '—' }}</p>
      </div>
      <div>
        <p>
          {{ localStorage.translations.pages.planning_orders.table['telefon'] }}:
          {{ companiesConfig?.phone || '—' }}
        </p>
        <p>{{ companiesConfig?.email || '—' }}</p>
      </div>
      <div>
        <p>
          {{ localStorage.translations.pages.planning_orders.table['y_tunnus'] }}:
          {{ companiesConfig?.company_id || '—' }}
        </p>
        <p>
          {{ localStorage.translations.pages.planning_orders.table['mesto-propiski'] }}:
          {{ companiesConfig?.registration_address_city  || '—'}}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "PlanningTableWorkShow",
  computed: {
    ...mapGetters(['companiesConfig']),
  },
  props: {
    formatDate: {
      type: String,
      default: ''
    },
    total: {
      type: [Number, String],
      default: ''
    }
  },
}
</script>

<style scoped lang="scss">
.text-primary {
  color: #277faf;
}

.grid {
  margin: 0 auto;
  display: grid;
  row-gap: 30px;
  width: 100%;
  
  &_header {
    display: grid;
    grid-template-columns: minmax(auto, 0.2fr) 1fr 1fr;
    grid-gap: 10px;
    width: 100%;
    padding: 20px;
  
    :deep() * {
      font-size: 18px;
      font-weight: 500;
    }
    
    @media #{map-get($display-breakpoints, 'xs-only')} {
      grid-template-columns: 1fr 1fr;
      padding: 30px 10px 10px;
      
      :deep() * {
        font-size: 16px !important;
      }
    }
    
    p {
      margin: 0;
      height: max-content;
    }
    
    & > div {
      display: grid;
      row-gap: 10px;
      grid-template-rows: repeat(2, max-content);
      
      &:nth-of-type(1) {
        width: auto;
        justify-self: flex-start;
      }
      
      &:nth-of-type(2) {
        justify-self: flex-start;
        align-content: flex-end;
        
        @media #{map-get($display-breakpoints, 'xs-only')} {
          justify-self: end;
          * {
            text-align: end;
          }
        }
      }
      
      &:nth-of-type(3) {
        justify-self: flex-end;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        
        * {
          text-align: end;
        }
        
        @media #{map-get($display-breakpoints, 'xs-only')} {
          grid-column: 1/3;
          justify-self: end;
          padding-top: 15px;
        }
      }
    }
  }
  
  &_footer {
    display: grid;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 12px;
  
    :deep() * {
      font-size: 18px;
      font-weight: 500;
    }
  
    @media #{map-get($display-breakpoints, 'sm-and-down')} {
      grid-template-columns: 1fr;
    
      :deep() * {
        font-size: 16px !important;
      }
    }
    
    & > div {
      display: grid;
      row-gap: 10px;
  
      &:nth-of-type(2) {
        justify-content: center;
    
        @media #{map-get($display-breakpoints, 'sm-and-down')} {
          justify-content: start;
        }
      }
      &:nth-of-type(3) {
        justify-content: end;
    
        @media #{map-get($display-breakpoints, 'sm-and-down')} {
          justify-content: start;
        }
      }
    }
  }
}

.logo {
  max-height: 60px;
  height: 100%;
  width: auto;
}

p {
  margin: 0;
}
</style>
